export default __webpack_public_path__ + "static/media/head01_zh_tw_sp.3866dcfc.png";